<template>
  <v-btn
    :class="buttonClass"
    :disabled="disabled"
    :loading="loading"
    @click="$emit('next')"
  >
    {{ buttonText }}
    <v-icon class="white--text pl-5">
      mdi mdi-save-outline
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveButtonState: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    buttonText() {
        let status = this.saveButtonState
        return status === 'success' ? 'Changes Are Saved' : status === 'error'  ? 'Error' : 'Save Changes'
    },
    buttonClass() {
      let status = this.saveButtonState
      return status === 'success' ? 'success' : status === 'error'  ? 'warning' : 'error'
    },
  },
}
</script>

<style lang="scss" scoped>
</style>